import { FormatFloatCenterIcon } from './FormatFloatCenterIcon';

/**
 * author: Andreas Gohr
 * id 3BC78F10-A7C3-4F15-9328-138E35CFC259
 * name format-float-center
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-float-center.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatFloatCentreIcon = FormatFloatCenterIcon;
export default FormatFloatCentreIcon